import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import PostControls from 'flarum/forum/utils/PostControls';
//import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
import * as msdk from './utils/msdk';

app.initializers.add('weiqi/forum-go-extend/flarum-share-links', () => {
  const shareQQLinkLinkButtonComponent = (route, data, is_post) => {
    const url = app.forum.attribute('baseUrl') + route;
    var title = data.data.attributes.title;
    if (is_post) {
        const post_id = data.data.relationships.discussion.data.id;
        title = data.store.data.discussions[post_id].data.attributes.title;
    }
    return (
      <Button
        icon="fas fa-share"
        onclick={() => {

          var link = '{"channel":"QQ","MsdkMethod":"sendMsgWebView","actionReport":"MSG_INVITE","desc":"","imagePath":"","link":"'+url+'","messageExt":"messageExt","tailLogo":"WECHAT_SNS_JUMP_APP","thumbPath":"https:\/\/dlied5.qq.com\/hlgame\/hlwq\/terminal\/client\/com_tencent_msdk_push_icon.png","title":"【论坛】'+ title +'","type":10001,"user":""}';

          //console.log(link + ', is harmony: ' + msdk.isHarmony());
          if (msdk.isHarmony()) {
              msdk.harmonyShareToQQ(link);
          } else {
              msdk.msdkCall(link);
          }
        }}
      >
        {app.translator.trans('forum-go-extend-share-links.forum.share_qq_link_button')}
      </Button>
    );
  };

  const shareQQZoneLinkLinkButtonComponent = (route, data, is_post) => {
    const url = app.forum.attribute('baseUrl') + route;
    var title = data.data.attributes.title;
    if (is_post) {
        const post_id = data.data.relationships.discussion.data.id;
        title = data.store.data.discussions[post_id].data.attributes.title;
    }
    return (
      <Button
        icon="fas fa-share"
        onclick={() => {

          var link = '{"channel":"QQ","MsdkMethod":"shareWebView","actionReport":"MSG_INVITE","desc":"","imagePath":"","link":"'+ url +'","messageExt":"messageExt","tailLogo":"WECHAT_SNS_JUMP_APP","thumbPath":"https:\/\/dlied5.qq.com\/hlgame\/hlwq\/terminal\/client\/com_tencent_msdk_push_icon.png","title":"【论坛】'+ title +'","type":10001,"user":""}';

          msdk.msdkCall(link);
        }}
      >
        {app.translator.trans('forum-go-extend-share-links.forum.share_qq_zone_link_button')}
      </Button>
    );
  };

  const shareWXLinkLinkButtonComponent = (route, data, is_post) => {
    const url = app.forum.attribute('baseUrl') + route;
    var title = data.data.attributes.title;
    if (is_post) {
        const post_id = data.data.relationships.discussion.data.id;
        title = data.store.data.discussions[post_id].data.attributes.title;
    }
    return (
      <Button
        icon="fas fa-share"
        onclick={() => {

          var link = '{"channel":"WeChat","MsdkMethod":"sendMsgWebView","actionReport":"MSG_INVITE","desc":"","imagePath":"","link":"'+ url +'","messageExt":"messageExt","tailLogo":"WECHAT_SNS_JUMP_APP","thumbPath":"https:\/\/dlied5.qq.com\/hlgame\/hlwq\/terminal\/client\/com_tencent_msdk_push_icon.png","title":"【论坛】'+ title +'","type":10001,"user":""}';

          msdk.msdkCall(link);
        }}
      >
        {app.translator.trans('forum-go-extend-share-links.forum.share_wx_link_button')}
      </Button>
    );
  };

  const shareWXZoneLinkLinkButtonComponent = (route, data, is_post) => {
    const url = app.forum.attribute('baseUrl') + route;
    var title = data.data.attributes.title;
    if (is_post) {
        const post_id = data.data.relationships.discussion.data.id;
        title = data.store.data.discussions[post_id].data.attributes.title;
    }
    return (
      <Button
        icon="fas fa-share"
        onclick={() => {

            var link = '{"channel":"WeChat","MsdkMethod":"shareWebView","actionReport":"MSG_INVITE","desc":"","imagePath":"","link":"'+ url +'","messageExt":"messageExt","tailLogo":"WECHAT_SNS_JUMP_APP","thumbPath":"https:\/\/dlied5.qq.com\/hlgame\/hlwq\/terminal\/client\/com_tencent_msdk_push_icon.png","title":"【论坛】'+ title +'","type":10001,"user":""}';

          msdk.msdkCall(link);
        }}
      >
        {app.translator.trans('forum-go-extend-share-links.forum.share_wx_zone_link_button')}
      </Button>
    );
  };
  
  if (msdk.isMobile()) {
    extend(DiscussionControls, 'userControls', function (items, discussion) {
      items.add('shareWXLink',shareWXLinkLinkButtonComponent(app.route.discussion(discussion), discussion));
      items.add('shareWXZoneLink',shareWXZoneLinkLinkButtonComponent(app.route.discussion(discussion), discussion));
      items.add('shareQQLink',shareQQLinkLinkButtonComponent(app.route.discussion(discussion), discussion));
      items.add('shareQQZoneLink',shareQQZoneLinkLinkButtonComponent(app.route.discussion(discussion), discussion));
    });
  
    extend(PostControls, 'userControls', function (items, post) {
      items.add('shareWXLink',shareWXLinkLinkButtonComponent(app.route.post(post), post, true));
      items.add('shareWXZoneLink',shareWXZoneLinkLinkButtonComponent(app.route.post(post), post, true));
      items.add('shareQQLink', shareQQLinkLinkButtonComponent(app.route.post(post), post, true));
      items.add('shareQQZoneLink',shareQQZoneLinkLinkButtonComponent(app.route.post(post), post, true));
    });  
  }
});
